<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            RETRATOS DE PRENSA <br>
            <span style="line-height: 100%;" class="fontMS300">
                LA PLUMA DE <br> MÁLAGA GRENET <br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio12/malaga-grenet">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio12/malaga-grenet">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio12/malaga-grenet">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE001.jpg">
</section>
<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-6">
                <a href="http://hdl.handle.net/20.500.14428/79566" target="_blank">
                    <img width="100%" src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE002.jpg">
                </a>
                <p class="fontMS100Italic">
                    Julio Málaga Grenet. París, ca. 1935.
                </p>
            </div>
            <div class="col-sm-6">
                <p class="fontMS500 font-24">
                    JULIO MÁLAGA GRENET (AREQUIPA, 1886 – LIMA, 1963) FUE UN PROLÍFICO ARTISTA QUE DESTACÓ COMO FIGURA
                    CLAVE EN EL DESARROLLO DEL ARTE GRÁFICO A INICIOS DEL SIGLO XX.
                </p>
                <p class="fontMS100 text-justify font-24">
                    Su producción se insertó en medio de un renacimiento de la prensa ilustrada que se caracterizó por
                    propiciar la reflexión y crítica de la ciudadanía sobre los asuntos públicos y los vaivenes
                    políticos del país. Su legado fue la renovación del género de la caricatura con su agudo humor y su
                    depurado estilo. La Biblioteca Nacional del Perú cuenta con una colección de más de un centenar de
                    retratos a tinta realizados para el diario limeño <span class="fontMS100Italic">La Crónica</span>
                    entre 1944 y 1956, además de ilustraciones impresas realizadas en París y Nueva York. Este acervo se
                    convierte en testimonio de la cultura gráfica peruana.
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoAzulO_CH">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            LOS ANTECEDENTES
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40 subtitleSubsec">
                    DE LA CARICATURA POLÍTICA EN EL PERÚ
                    <br>
                    EN EL SIGLO XIX
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <p class="fontMS100 text-justify text-white font-24">
                    <br>
                    Desde mediados del siglo XIX, en un escenario político inestable, la caricatura se distribuye a
                    través de publicaciones intermitentes como crítica al usufructo del poder. Luego de la Guerra del
                    Pacífico (1879-1884) las disputas entre los partidos políticos caudillistas, sus luchas por el poder
                    y la corrupción de la clase gobernante son ridiculizadas cáusticamente.
                    <br><br>
                </p>
                <!--CEL-->
                <div class="row p2 menuWebPhone">
                    <div class="col-sm-4">
                        <div class="row libro text-right">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79245 " target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE003.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Libre ejercicio de la ciudadanía<br>
                                        1855
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="row libro text-right">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79240 " target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE008.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Ramón Castilla amonestado por el pueblo<br>
                                        1859
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-8">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79247 " target="_blank">
                                <img class="img-fluid" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE004.jpg">
                                <div class="overlay2">
                                    <p class="fontMS100 text-center">
                                        La Alianza Americana<br>
                                        1867
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79245 " target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE003.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Libre ejercicio de la ciudadanía<br>
                                        1855
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79240 " target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE008.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Ramón Castilla amonestado por el pueblo<br>
                                        1859
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-12 libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79247 " target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE004.jpg">
                                <div class="overlay2">
                                    <p class="fontMS100 text-center">
                                        La Alianza Americana<br>
                                        1867
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

                <!--CEL-->
                <div class="row p2 menuWebPhone">
                    <div class="col-sm-8">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79241" target="_blank">
                                <img class="img-fluid" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE006.jpg">
                                <div class="overlay2">
                                    <p class="fontMS100 text-center">
                                        El último día de César<br>
                                        1874
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="row text-right">
                            <div class="libro">
                                <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79248 "
                                    target="_blank">
                                    <img class="img-fluid mb-3" width="100%"
                                        src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE005.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            Mandando solo por amor al guano…<br>
                                            1874
                                        </p>
                                    </div>
                                </a>
                            </div>

                        </div>
                        <div class="row text-right">
                            <div class="libro">
                                <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79244 "
                                    target="_blank">
                                    <img class="img-fluid mb-3" width="100%"
                                        src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE009.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            Teatro político: No quiero… porque no puedo<br>
                                            1886
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79241" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE006.jpg">
                                <div class="overlay2">
                                    <p class="fontMS100 text-center">
                                        El último día de César<br>
                                        1874
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79244 " target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE009.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Teatro político: No quiero… porque no puedo<br>
                                        1886
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79248 " target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE005.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Mandando solo por amor al guano…<br>
                                        1874
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

                <!--CEL-->
                <div class="row p2 menuWebPhone">
                    <div class="col-sm-4">
                        <p class="mt-3">
                            <br><br>
                        </p>
                        <div class="row text-right">
                            <div class="libro">
                                <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79243"
                                    target="_blank">
                                    <img class="img-fluid mb-3" width="100%"
                                        src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE011.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            La Unión Cívica<br>
                                            1892
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="row text-right">
                            <div class="libro">
                                <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79242 "
                                    target="_blank">
                                    <img class="img-fluid" width="100%"
                                        src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE010.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            La penitencia en la culpa<br>
                                            1893
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-8">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79246 " target="_blank">
                                <img class="img-fluid " width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE012.jpg">
                                <div class="overlay2">
                                    <p class="fontMS100 text-center">
                                        Este cordero es mi cuerpo...<br>
                                        1896
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79243" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE011.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        La Unión Cívica<br>
                                        1892
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79242 " target="_blank">
                                <img class="img-fluid" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE010.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        La penitencia en la culpa<br>
                                        1893
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79246" target="_blank">
                                <img class="img-fluid " width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE012.jpg">
                                <div class="overlay2">
                                    <p class="fontMS100 text-center">
                                        Este cordero es mi cuerpo...<br>
                                        1896
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-8">
                        <p style="line-height: 150%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-40">
                            CARICATURA POLÍTICA INICIAL
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS300 colorPrincipal font-40">
                    DE JULIO MÁLAGA GRENET
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 2%;margin-bottom: 0%;" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <div class="row p3">
                    <div class="col-sm-6">
                        <p class="fontMS500 font-24">
                            A COMIENZO DEL SIGLO XX HUBO UN MOVIMIENTO EDITORIAL QUE SE ORIENTABA A LA CREACIÓN DE
                            REVISTAS Y DIARIOS CON SECCIONES INFORMATIVAS, POLÍTICAS, LITERARIAS O DE ACTUALIDAD
                            DIRIGIDAS A CAPTAR UN PÚBLICO MASIVO.
                        </p>
                        <p class="text-justify font-24">
                            Durante los gobiernos de José Pardo (1904-1908) y Augusto B. Leguía (1908-1912) se crean una
                            docena de estas publicaciones. Entre los medios con los que colabora un joven Málaga Grenet
                            destacan la revista ilustrada de temas literarios <span class="fontMS100Italic">Actualidades
                            </span>(1904), el semanario satírico y de caricaturas <span class="fontMS100Italic"> Monos y
                                Monadas </span>(1905) como director artístico, la revista semanal ilustrada <span
                                class="fontMS100Italic">Variedades </span>(1908) y <span class="fontMS100Italic">El
                                Fígaro, Ilustración Peruana</span> y <span class="fontMS100Italic">Gil Blas
                            </span>(1909). También fue director artístico de la revista <span
                                class="fontMS100Italic">Zig Zag</span> de Chile y <span class="fontMS100Italic">Caras y
                                Caretas</span> de Argentina (1910). En los años veinte se introduce en el medio
                            publicitario de la ciudad de Nueva York. Hacia 1930 era ilustrador de revistas en París y
                            posteriormente se establece en Madrid.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <a href="http://hdl.handle.net/20.500.14428/79486" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE014.jpg">
                        </a>
                        <p class="fontMS100Italic">
                            Retrato de Roque Sáenz Peña.
                            Revista Actualidades.
                            1905.
                        </p>
                    </div>
                </div>

                <!--CEL-->
                <div class="row p2 menuWebPhone">
                    <div class="col-sm-3"></div>
                    <div class="col-sm-3">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79492" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE017b.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Semanario Monos y Monadas N° 21<br>
                                        1906
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79490" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE017c.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Semanario Monos y Monadas N° 24<br>
                                        1906
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3"></div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79492" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE017b.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Semanario Monos y Monadas N° 21<br>
                                        1906
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79490" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE017c.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Semanario Monos y Monadas N° 24<br>
                                        1906
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

                <!--CEL-->
                <div class="row p2 menuWebPhone">
                    <div class="col-sm-3">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79491" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE015.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Revista Variedades N° 1<br>
                                        1908
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79489" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE017d.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Variedades N° 65<br>
                                        1909
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79488" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE020.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Revista Variedades
                                        1909
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79487" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE018.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Revista Variedades
                                        1909
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79491" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE015.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Revista Variedades N° 1<br>
                                        1908
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79489" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE017d.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Variedades N° 65<br>
                                        1909
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79488" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE020.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Revista Variedades
                                        1909
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" [routerLink]="['/ficha/DIB-15']" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE018.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Revista Variedades
                                        1909
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

                <!--CEL-->
                <div class="row p2 menuWebPhone">
                    <div class="col-sm-3"></div>
                    <div class="col-sm-3">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79568 " target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE016.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Semanario Gil Blas<br>
                                        1909
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79485" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE019.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Semanario Gil Blas<br>
                                        1909
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3"></div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79568 " target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE016.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Semanario Gil Blas<br>
                                        1909
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79485" target="_blank">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE019.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        Semanario Gil Blas<br>
                                        1909
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-5">
                        <p style="line-height: 160%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-40">
                            DIARIO LA CRÓNICA
                        </p>
                    </div>
                    <div class="col-sm-7">
                        <img class="LineSubsec_Izq" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-680.png">
                    </div>
                </div>
                <div class="row p4">
                    <div class="col-sm-6">
                        <p class="fontMS500 font-24">
                            <br><br>
                            MÁLAGA GRENET TUVO UNA COLABORACIÓN PERIÓDICA EN <span class="fontMS500Italic">LA
                                CRÓNICA</span>, DIARIO QUE JUNTO A <span class="fontMS500Italic">LA PRENSA</span> Y
                            <span class="fontMS500Italic">EL COMERCIO</span> SE CONVIRTIERON EN REFERENTES DE
                            INFORMACIÓN Y CON GRAN INFLUENCIA EN LA OPINIÓN PÚBLICA. <span class="fontMS500Italic">LA
                                CRÓNICA</span> CIRCULÓ A PARTIR DE 1912 CON UN FORMATO NOVEDOSO DE AGILIDAD INFORMATIVA,
                            SIENDO SU PRIMER DIRECTOR CLEMENTE PALMA.
                            <br>
                        </p>
                        <p class="text-justify font-24">
                            El diario se convierte en partidario del régimen de Augusto B. Leguía (1919-1930). En 1931
                            lo adquiere el hacendado azucarero Rafael Larco Herrera, y a través de sus páginas se apoya
                            al gobierno de Óscar Benavides (1933-1939) y luego a la candidatura y posterior presidencia
                            de Manuel Prado Ugarteche (1939-1945). En 1942 Larco transfiere el diario a la poderosa
                            familia Prado por deudas contraídas. A inicios de la década de 1950 se inicia la
                            modernización de <span class="fontMS100Italic">La Crónica</span> y la edición de la tarde se
                            desdobló en <span class="fontMS100Italic">La Segunda</span> que salía a mediodía y era
                            dirigida a lectores de provincia, y <span class="fontMS100Italic">La Tercera</span>, a
                            partir de las cuatro de la tarde, que se convirtió en un éxito periodístico.
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/html/1-malaga-grenet/la-cronica-edicion-de-la-manana-26-de-mayo-de-1944/"
                            target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE021.jpg">
                        </a>
                        <p class="fontMS100Italic">
                            Diario La Crónica. Lima, 26 de mayo de 1944.
                        </p>
                    </div>
                </div>

                <p class="text-justify font-24">
                    <br>
                    Desde ambas se promociona -nuevamente- la segunda presidencia de Manuel Prado (1956-1962).
                    En 1970 el gobierno de Juan Velasco Alvarado nacionalizó el Banco Popular (propiedad de los Prado) y
                    controló las acciones del periódico. Entre 1974 y 1975 el diario consigue notoriedad a través de una
                    redacción renovada. Con el retorno de la democracia en 1980, <span class="fontMS100Italic">La
                        Crónica</span> es conducida por directorios señalados por los gobiernos de turno. Finalmente,
                    en 1990 el diario se cierra y su archivo pasa a la empresa estatal Editora Perú.
                    <span class="fontMS100Italic">La Tercera</span> subsiste hasta 1992.
                    <br>
                </p>
                <div class="row p3">
                    <div class="col-sm-6">


                        <iframe width="100%" height="415" src="https://www.youtube.com/embed/81zGUkAzJf8?si=ohFsu4RdEzj9F5aQ"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>

                        <p class="text-justify fontMS100Italic">
                            Curso de natación de La Crónica. Noticiarios peruanos de los 40, película grabada en cintas
                            de nitrato de 35 mm y digitalizada en la Biblioteca Digital BNP
                        </p>
                    </div>
                    <div class="col-sm-6">


                        <iframe width="100%" height="415" src="https://www.youtube.com/embed/EcmRqeFnZDU"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>

                        <p class="text-justify fontMS100Italic">
                            La Crónica fomenta los deportes. Noticiarios peruanos de los 40, película grabada en cintas
                            de nitrato de 35 mm y digitalizada en la Biblioteca Digital BNP
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_RESALTE.png">
                <br><br>
                <p class="fontMS500 text-justify font-28">
                    ¿QUÉ ES LA CARICATURA? <br>
                    ES UN ARTE SUPERIOR PORQUE ES UNA ARMA DE COMBATE PODEROSA […] TIENE LA
                    HUMANÍSIMA MISIÓN DE HACER REÍR A LOS QUE HAN LLORADO Y DE HACER LLORAR A LOS QUE SE HAN REÍDO.<br>
                </p>
                <p class="fontMS500Italic font-28 text-right">
                    ENTREVISTA DE ALFONSINA BARRIONUEVO A JULIO MÁLAGA GRENET,<br> CARETAS N° 92, 1955.
                </p>
                <img id="img_rotate" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_RESALTE.png">
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            EL LÁPIZ DE MÁLAGA GRENET
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <div class="row p3">
                    <div class="col-sm-6 p3">
                        <p class="font-24">
                            A su regreso al Perú en 1940, con una trayectoria y prestigio sólidos, se integra
                            como colaborador de las revistas <span class="fontMS100Italic">Excélsior</span> y <span
                                class="fontMS100Italic">Cultura Peruana</span>.
                            <br><br>
                            A partir de 1944 colabora en el diario <span class="fontMS100Italic">La Crónica</span> hasta
                            1956 con la sección "El lápiz de Málaga Grenet" en el que publica retratos a pincel y tinta
                            de personajes de la política, la diplomacia, la industria y la cultura.

                            Este notable conjunto de caricaturas se caracteriza por la abstracción de los rasgos y las
                            expresiones a través de la línea, señalando la aguda capacidad de observación e
                            interpretación psicológica del representado.
                            <br><br>
                            Paralelamente, fue profesor de Artes Gráficas y subdirector en la Escuela Nacional de Bellas
                            Artes en 1945, siendo nombrado director interino en 1956.
                            <br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <img width="100%" src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE024.jpg">
                    </div>
                </div>

                <!--CEL-->
                <div class="row menuWebPhone">
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79219">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE025.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Luis Alayza Paz Soldán<br>
                                        1944
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79238">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE026.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        José Luis Subercaseaux<br>
                                        Ca. 1945
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79231">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE027.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Francisco Echenique<br>
                                        1946
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79237">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE037.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Fernando Wiese<br>
                                        1946
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79219">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE025.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Luis Alayza Paz Soldán<br>
                                        1944
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79238">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE026.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        José Luis Subercaseaux<br>
                                        Ca. 1945
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79231">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE027.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Francisco Echenique<br>
                                        1946
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79237">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE037.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Fernando Wiese<br>
                                        1946
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!--CEL-->
                <div class="row menuWebPhone">
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79229 ">

                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE028.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Georges Rouma<br>
                                        1947
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79234">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE029.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Harol H. Tittmann<br>
                                        1948
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79228 ">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE038.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Roque Saldías Maninat<br>
                                        1948
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79227">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE030.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Andrey Vyshinsky<br>
                                        1949
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79229 ">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE028.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Georges Rouma<br>
                                        1947
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79234">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE029.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Harol H. Tittmann<br>
                                        1948
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79228">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE038.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Roque Saldías Maninat<br>
                                        1948
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79227">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE030.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Andrey Vyshinsky<br>
                                        1949
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!--CEL-->
                <div class="row menuWebPhone">
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79230">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE039.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Gino Bianchini<br>
                                        1949
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79235">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE031.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Alberto Barrón Vita<br>
                                        1950
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79233">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE040.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Luis Alberto Ayllón<br>
                                        1951
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79222 ">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE032.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Mamerto Urriolagoitia<br>
                                        1951
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79230">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE039.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Gino Bianchini<br>
                                        1949
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79235">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE031.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Alberto Barrón Vita<br>
                                        1950
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79233">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE040.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Luis Alberto Ayllón<br>
                                        1951
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79222">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE032.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Mamerto Urriolagoitia<br>
                                        1951
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!--CEL-->
                <div class="row menuWebPhone">
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79236 ">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE033.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Adolfo Ruiz Cortinez <br>
                                        1952
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79220">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE034.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Óscar Berckemeyer<br>
                                        1954
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79224">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE035.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Ernesto Sánchez Rubirosa<br>
                                        Ca. 1955
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79223">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE036.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Cristóbal de Losada y Puga<br>
                                        Ca. 1956
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79236">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE033.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Adolfo Ruiz Cortinez <br>
                                        1952
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79220">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE034.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Óscar Berckemeyer<br>
                                        1954
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79224">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE035.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Ernesto Sánchez Rubirosa<br>
                                        Ca. 1955
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79223">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE036.jpg">
                                <div class="overlay4">
                                    <p class="fontMS100 text-center">
                                        Cristóbal de Losada y Puga<br>
                                        Ca. 1956
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 titleSubsec">
                            LAS REINAS DEL TRABAJO
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <p class="text-justify font-28">
                    <br>
                    El diario <span class="fontMS100Italic">La Crónica</span> organizó y promovió un concurso de belleza
                    entre las trabajadoras de Lima en los años cuarenta. Se dio un despliegue desde las páginas del
                    periódico a este tipo de actividades muy esperadas por la comunidad laboral obrera insertándose no
                    solo en el imaginario popular, sino además en la agenda política.

                    Se indicaba que la Reina del trabajo debía ser elegida “por su belleza, virtud y laboriosidad”. Para
                    su nombramiento la población emitía el voto por su candidata preferida en el local del diario. Luego
                    se realizaba el festejo y la coronación estaba a cargo de la Municipalidad de Lima. <br><br>
                </p>

                <!--CEL-->
                <div class="row menuWebPhone">
                    <div class="col-sm-4 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79239">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE041.jpg">
                                <div class="overlay5">
                                    <p class="fontMS100 text-center">
                                        Renée Guerra<br>
                                        1944
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-4 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79221">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE043.jpg">
                                <div class="overlay5">
                                    <p class="fontMS100 text-center">
                                        Rosa Amelia Cevasco<br>
                                        1948
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-4 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79225">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE044.jpg">
                                <div class="overlay5">
                                    <p class="fontMS100 text-center">
                                        María Luisa de la Borda<br>
                                        1954
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-4 p2">
                        <div class="libro">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79232">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE042.jpg">
                                <div class="overlay5">
                                    <p class="fontMS100 text-center">
                                        Armandina Dongo<br>
                                        1945
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-8 p2">
                        <p>
                            <br><br>
                        </p>
                        <iframe width="100%" height="415" src="https://www.youtube.com/embed/e_w7YrE70yc"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                        <p class="fontMS100Italic text-justify">
                            Armandina I, reina del trabajo. Noticiaros peruanos de los años 40, película grabada en
                            cintas de nitrato de <br>35 mm y digitalizada en la Biblioteca Virtual BNP
                        </p>
                    </div>
                </div>
                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79239">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE041.jpg">
                                <div class="overlay5">
                                    <p class="fontMS100 text-center">
                                        Renée Guerra<br>
                                        1944
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79221">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE043.jpg">
                                <div class="overlay5">
                                    <p class="fontMS100 text-center">
                                        Rosa Amelia Cevasco<br>
                                        1948
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;" href="http://hdl.handle.net/20.500.14428/79225">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE044.jpg">
                                <div class="overlay5">
                                    <p class="fontMS100 text-center">
                                        María Luisa de la Borda<br>
                                        1954
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab">
                            <a target="_blank" style="color: inherit;"
                                href="http://hdl.handle.net/20.500.14428/79232">
                                <img class="img-fluid mb-3" width="100%"
                                    src="/assets/images/micrositio/micrositio12/ET02-MS05_GRE042.jpg">
                                <div class="overlay5">
                                    <p class="fontMS100 text-center">
                                        Armandina Dongo<br>
                                        1945
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-12 libro">
                            <iframe width="100%" height="415" src="https://www.youtube.com/embed/e_w7YrE70yc"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>
                            <p class="fontMS100Italic text-justify">
                                Armandina I, reina del trabajo. Noticiaros peruanos de los años 40, película grabada en
                                cintas de nitrato de <br>35 mm y digitalizada en la Biblioteca Virtual BNP
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoVerde">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/79226 " target="_blank">
                            <img width="100%" src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE045.jpg">
                        </a>
                        <p>
                            <br>
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <p class="text-justify text-white font-28">
                            <br>
                            De las caricaturas de Málaga Grenet que se conservan en la Biblioteca Nacional del Perú para
                            su publicación en el diario <span class="fontMS100Italic">La Crónica</span>, existe la de un
                            trabajador de la misma biblioteca con el cargo de portero, José Jara Aguilar. Usualmente,
                            dibujaba personajes públicos que tenían cargos de poder. El retrato de un “anónimo”
                            convierte esta obra como disímil en la colección, una irrupción solitaria en el repertorio
                            oficial encargado al artista.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="fontMS500  text-white font-28">
                            ¿Qué diferencias y coincidencias encuentras entre el personaje de esta caricatura y los
                            demás?


                            <br><br>
                            <img width="100%"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="fontMS500  text-white font-28">
                            ¿La sátira gráfica sigue siendo un elemento para la expresión libre y crítica en nuestra
                            sociedad?

                            <br><br>
                            <img width="100%"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="fontMS500  text-white font-28">
                            ¿Los medios impresos tienen el mismo impacto que las redes sociales en la Internet?

                            <br><br>
                            <img width="100%"
                                src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 200%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <p class="fontMS100 font-22">
                    <br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Los retratos jocoserios de Julio Málaga Grenet (2016)
                            </span><br>

                            <span class="fontMS100">Catálogo de exposición. Biblioteca Nacional del Perú.
                                <br></span>
                            <a href="https://www.academia.edu/41974255/LOS_RETRATOS_JOCOSERIOS" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Tauzin-Castellanos, I. (2009)
                            </span><br>
                            La caricatura en la prensa satírica peruana <br>
                            (1892-1909).
                            <span class="fontMS100">
                                Historia de la República del Perú <br> [1822-1933]. <br>
                            </span>
                            <a href="http://repositorio.pucp.edu.pe/index/handle/123456789/113656" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Rivera Escobar, R. (2006)
                            </span><br>
                            Caricatura en el Perú. El período clásico
                            (1904-1931).
                            <span class="fontMS100">
                                Lima: Biblioteca Nacional del Perú –
                                Universidad San Martín de Porres. <br>
                            </span>
                            <a href="http://repositoriodigital.bnp.gob.pe/bnp/recursos/2/fondo-editorial/FE_006/files/assets/basic-html/page-3.html"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Kusunoki, R. (2014)
                            </span><br>
                            La rebelión de los lápices. El Perú del siglo XIX
                            en caricaturas.
                            <span class="fontMS100">
                                Lima: Biblioteca Nacional del Perú. <br>
                            </span>
                            <a href="http://repositoriodigital.bnp.gob.pe/bnp/recursos/2/fondo-editorial/FE_023/files/assets/basic-html/page-3.html"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Llosa Málaga, A. (2016)
                            </span><br>
                            Julio Málaga Grenet y la renovación de la caricatura en el Perú en la época de Leguía:
                            1904-1909.
                            <span class="fontMS100">
                                Tesis para obtener el grado de Magíster en
                                Historia del Arte PUCP. <br>
                            </span>
                            <a href="http://tesis.pucp.edu.pe/repositorio/handle/20.500.12404/7214" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="fontMS100Italic font-22">
                            <br>
                            <span class="fontMS500">
                                Gargurevich, J. (2013)
                            </span><br>
                            La Prensa y La Crónica, viejos acorazados que volverían a flote.
                            <span class="fontMS100">
                                Conexión N° 2, pp. 8-33. Departamento de Comunicaciones PUCP. <br>
                            </span>
                            <a href="http://revistas.pucp.edu.pe/index.php/conexion/article/view/11563/12087"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>